export default __webpack_public_path__ + "assets/maldives-flag.png";